import { ValidPhoneCode } from '../formatters/format-phone';

/** Символ маски на месте ещё не введённой цифры. */
export const PHONE_MASK_SLOT = '_';

const S = PHONE_MASK_SLOT;

export const getPhoneMask = (code: ValidPhoneCode) => {
  switch (code) {
    case '+7':
      return `(${S}${S}${S}) ${S}${S}${S}-${S}${S}-${S}${S}`;
    case '+375':
      return `(${S}${S}) ${S}${S}${S}-${S}${S}-${S}${S}`;
    case '+374':
      return `(${S}${S}) ${S}${S}${S}-${S}${S}${S}`;
    default:
      return `(${S}${S}) ${S}${S}${S}-${S}${S}-${S}${S}`;
  }
};

/** Сколько цифр в номере по маске выбранной страны. */
export const getPhoneDigitsCount = (code: ValidPhoneCode) => getPhoneMask(code).split(PHONE_MASK_SLOT).length - 1;
